/*@ngInject*/
const ProposalAttachmentRepository = function (baseRepository, sectionType) {

    angular.extend(this, baseRepository);

    this.saveAttachment = function (proposalId, data, file) {
        var url = '/rest/Proposal/'+proposalId+'/uploadSectionFromFile',
            formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                // When you assign undefined, the content type defaults to multipart/form-data
                headers: {
                    'Content-Type': undefined
                },
                params:{
                    displayLabel: data.description,
                    filename:data.name,
                    length:data.fileExpectedSize
                }
            };

        formData.append('file', file);

        return this.post(url, formData, config);
    };
};

angular.module('gw-um-submission')
    .service('proposalAttachmentRepository', ProposalAttachmentRepository);
